import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { ReduxState } from '../../interfaces';
import { useLifecycle } from '../../hooks/useLifecycle';
import Datatable from '../../modules/datatable/datatable';
import RightPanel from '../shared/rightPanel';
import RightPanelSelector from '../shared/rightPanelSelector';
import ModalSelector from '../shared/modalSelector';
import { PanelsType, ModalsType } from '../../modules/dialogs/model';

import * as DTypes from '../../modules/devicetypes';
import DataTableSummary from '../shared/datatable/summary';
import { AppKeys } from '../../core/localization';
import Scrim from '../shared/scrim';

interface StateProps {
  dTypesState: DTypes.State;
  activeDialog: PanelsType;
  activeModal: ModalsType;
}

type Props = StateProps;

const DeviceTypeContent: React.FC<Props> = (props) => {
  useLifecycle('DeviceTypeContent');

  useEffect(() => {
    props.dTypesState.pagesToLoad.forEach((pageIdx) => {
      DTypes.searchPage(pageIdx);
    });
  }, [props.dTypesState.pagesToLoad]);

  return (
    <div className="layout__content__main" style={{ height: '100%' }}>
      <RightPanel
        isOpened={!!props.activeDialog}
        content={<RightPanelSelector activeDialog={props.activeDialog} />}
      >
        <DataTableSummary
          dtState={props.dTypesState}
          clearSelection={DTypes.clearSelection}
          msgMain={AppKeys.Num_DTypes}
        />
        <Scrim
          isActive={props.dTypesState.table.isLoading}
          fullHeight
          hideSpinner
        >
          <div className="layout__content__table_wrapper">
            <div className="datatable__layout">
              <Datatable
                rows={props.dTypesState.table.content}
                getPK={props.dTypesState.selection.getPK}
                isLoading={false}
                columns={props.dTypesState.table.columns}
                // getTrProps={getTrProps}
                isSelectable
                allSelected={props.dTypesState.selection.isAllSelected}
                onToggleItemSelection={DTypes.updateTableItemSelection}
                isItemSelected={DTypes.isTableItemSelected}
                onToggleAllSelected={DTypes.updateTableSelectAll}
                pagination={props.dTypesState.table.pagination}
                onPageChange={DTypes.changeTablePage}
                onPageSizeChange={DTypes.changeTableSizePage}
                sortCriteria={props.dTypesState.sort}
                onSortCriteriaChanged={DTypes.changeTableSorting}
              />
            </div>
          </div>
        </Scrim>
      </RightPanel>
      <ModalSelector activeModal={props.activeModal} />
    </div>
  );
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  dTypesState: state.deviceTypesState,
  activeDialog: state.dialogState.activeDialog,
  activeModal: state.dialogState.activeModal,
});

export default connect(mapStateToProps)(DeviceTypeContent);
